import Block from './Block';

export default function Page({item}) {
  
  return (
    <div className="Page">
      <h1 className="LogoTitle">FRANKENSTEIN</h1>
      {item.value.blocks.map((block, index) => {
        return (
          <Block key={index} {...block} />
        );
      })}
    </div>
  );
}
